// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeGrid_wrapper__-AJCi","bgLine":"TimeGrid_bgLine__Bw7+N","isVisible":"TimeGrid_isVisible__0XT-i","time":"TimeGrid_time__0A-AN"};